import "./style.css";

import Swiper from "../../node_modules/swiper";
import "swiper/swiper-bundle.css";

export default class Carousel {
  static selector = ".carousel";

  constructor(block) {
    this.block = block;

    this.carouselContainer = this.block.querySelector(".swiper-container");
    this.slidesWrapper = this.block.querySelector(".swiper-wrapper");
  }

  initCarousel = () => {
    this.swiper = new Swiper(this.carouselContainer, {
      slidesPerView: "auto",
      spaceBetween: 21,
      breakpoints: {
        765: {
          slidesPerView: 3,
        },
      },
    });
  };

  onReady = () => {
    if (this.carouselContainer) {
      this.initCarousel();
    }
  };

  onDestroy = () => {
    this.swiper.destroy();
  };
}
